import { createContext } from "react";

const RelatedResultContext = createContext();

export default RelatedResultContext;
